import { globalAPIDictionary } from "@core/global/global-country-dictionary";
import { updateFavouriteTagsHandler } from "@redux/Bookmark/bookmark.action";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { components } from "react-select";
import CreateReactSelect from "react-select/creatable";
import axios from "axios";
import { captureException } from "@sentry/react";

export const UpdateFavouriteModal = ({ showFavModal, selectedCompanyArray, setShowFavModal, payload, clearSelection, type, setSingleData, setPayload }) => {
  const [tags, setTags] = useState([]);
  const [tagList, setTagList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCompanyArray && selectedCompanyArray.length === 1) {
      setTags(selectedCompanyArray[0]?.tags?.map((tag) => ({ label: tag, value: tag })));
    }
  }, [selectedCompanyArray]);

  useEffect(() => {
    if (showFavModal) {
      let url = globalAPIDictionary.usersAllFavouriteCompanyTags + "?type=" + type;
      axios
        .get(url)
        .then(({ data }) => {
          if (data.favouriteCompanyTags && data?.favouriteCompanyTags?.length) {
            let companyTags = data.favouriteCompanyTags.map((item) => ({ label: item, value: item }));
            setTagList(companyTags);
          }
        })
        .catch((err) => {
          captureException(err);
        });
    }
  }, [showFavModal]);

  const onSubmitHandler = () => {
    let favPayload = [...selectedCompanyArray].map((payload) => {
      let updatedPayload = { ...payload };
      delete updatedPayload.serial_no;
      delete updatedPayload.contactsCount;
      if (tags?.length) {
        return { ...updatedPayload, isAppendTags: selectedCompanyArray.length === 1 ? false : true, tags: tags?.length ? tags.map((tag) => tag.value) : [] };
      } else {
        return { ...updatedPayload, isAppendTags: false, tags: tags?.length ? tags.map((tag) => tag.value) : [] };
      }
    });
    let payloadClone = {
      ...payload,
      filters: {
        tagList: [],
        type: [],
        dataSource: [],
      },
    };
    if (setPayload) {
      dispatch(updateFavouriteTagsHandler({ updateFav: favPayload, payload: payloadClone }));
      setPayload(payloadClone);
    }
    clearSelection();
    setSingleData({});
    setShowFavModal(false);
  };

  return (
    <div>
      <Modal
        size="lg"
        centered
        show={showFavModal}
        onHide={() => {
          setShowFavModal(false);
          setSingleData({});
        }}>
        <Modal.Header closeButton>
          <Modal.Title>{tags?.length ? "Update" : "Add"} Tags</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="w-75 m-auto">
              <p className="add_to_fav_input_heading">Add customized tags for easy access in the dashboard</p>
              <CreateReactSelect
                options={tagList}
                isMulti
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                  NoOptionsMessage: (props) => (
                    <components.NoOptionsMessage {...props}>
                      <p className="text-left mb-0">Type to enter tags</p>
                    </components.NoOptionsMessage>
                  ),
                }}
                isOptionDisabled={() => tags && tags?.length >= 10}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    border: state.isFocused ? " 1px solid #6F08F1" : "",
                    "&:hover": {
                      border: "1px solid #6F08F1",
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 1000,
                  }),
                  multiValue: (baseStyles) => ({
                    ...baseStyles,
                    borderRadius: "100px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                  }),
                }}
                onChange={(e) => {
                  setTags(e);
                }}
                value={tags}
                placeholder={"You can add upto 10 tags"}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="fav-modal-cancel"
            variant="secondary"
            onClick={() => {
              setShowFavModal(false);
            }}>
            Cancel
          </Button>
          <Button className="btn btn-primary trademo-new-btn" onClick={onSubmitHandler}>
            {tags?.length ? "Update" : "Add"} Tags
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
